var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscalable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 55,
    viewBox: "0 0 71 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6076 39.6022L65.5918 4.82399V7.75865H67.6719V2.119H60.3916V3.73033H64.032L9.29187 38.354L10.6076 39.6022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6719 51.2697V15.0096H59.3516V51.2697H57.2715V27.0946H48.9512V51.2697H46.8711V33.5399H38.5508V51.2697H36.4707V36.7626H28.1504V51.2697H26.0703V39.9852H17.75V51.2697H15.6699V43.2079H7.34961V51.2697H0V52.881H71V51.2697H67.6719ZM61.4316 16.621H65.5918V51.2697H61.4316V16.621ZM51.0312 28.7059H55.1914V51.2697H51.0312V28.7059ZM40.6309 35.1512H44.791V51.2697H40.6309V35.1512ZM30.2305 38.3739H34.3906V51.2697H30.2305V38.3739ZM19.8301 41.5965H23.9902V51.2697H19.8301V41.5965ZM9.42969 44.8192H13.5898V51.2697H9.42969V44.8192Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalable);
export default __webpack_public_path__ + "static/media/escalable.84917660819f41b67cf7ad6904b496a1.svg";
export { ForwardRef as ReactComponent };